import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  DialogContent,
  Grid,
  IconButton,
  Modal,
  TextField,
  InputLabel,
  Typography,
  MenuItem,
  FormControl,
} from "@mui/material";
import { get, postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import ModalHeader from "../../modals/ModalHeader";
import ModalFooter from "../../modals/ModalFooter";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { whiteColor } from "../../theme/setThemeColor";
import SmallLoader from "../../component/loading-screen/SmallLoader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
  height: "max-content",
  overflowY: "scroll",
};

const CreateUInvoiceModal = ({ onSuccess }) => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    //  address: "",
    // gst: "",
    amount: "",
    // igst: "",
    // sgst: "",
    // cgst: "",
    invoice_date: "",
    // status: "",
      invoice_no: "", 

    description: "",
    // quantity: "",
    // unit: "",
    hsn_sac_code: "",
    // price: "",
    // tax_rate: "",
  });
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]); // To store list of users (which contain establishment info)
  const [establishmentId, setEstablishmentId] = useState(""); // State to store selected establishment ID
const [hsnSacCodes, setHsnSacCodes] = useState([]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const refreshUsers = useCallback(async () => {
    setLoading(true);
    get(
      `${ApiEndpoints.GET_USERS_BIGG}?role=merchant`,
      "",
      setLoading,
      (res) => {
        setUsers(res.data.data); // Set the users (merchant profiles) from the API response
        setLoading(false);
      },
      (error) => {
        apiErrorToast(error);
        setLoading(false);
      }
    );
  }, []);
 useEffect(() => {
    if (open) {
      refreshUsers();
    }
  }, [open, refreshUsers]);
  const fetchHsnSacCodes = useCallback(() => {
  get(
    `${ApiEndpoints.GET_UTILS}?type=hsnsac`,
    "",
    () => {},
    (res) => {
      setHsnSacCodes(res.data.data || []);
    },
    (err) => {
      apiErrorToast(err);
    }
  );
}, []);
const fetchInvoiceNumber = useCallback(() => {
  get(
    ApiEndpoints.RANDOM_INVOICE_NO,
    "",
    () => {},
    (res) => {
      if (res.data?.data) {
        setFormData((prev) => ({
          ...prev,
          invoice_no: res.data.data,
        }));
      }
    },
    (err) => {
      apiErrorToast(err);
    }
  );
}, []);
useEffect(() => {
  if (open) {
    refreshUsers();
    fetchHsnSacCodes();
    fetchInvoiceNumber(); // ✅ fetch invoice number
  }
}, [open, refreshUsers, fetchHsnSacCodes, fetchInvoiceNumber]);


const resetForm = () => {
  setFormData({
    amount: "",
    invoice_date: "",
    description: "",
    hsn_sac_code: "",
  });
  setEstablishmentId("");
};


  const handleSubmit = () => {
    // const payload = new FormData();

    // Object.entries(formData).forEach(([key, value]) => {
    //   payload.append(key, value);
    // });

const selectedUser = users.find((user) => user.id === establishmentId);

if (!selectedUser) {
  apiErrorToast("Selected establishment not found.");
  return;
}

const userId = selectedUser.id;

if (!userId) {
  apiErrorToast("User ID not found.");
  return;
}

const payload = new FormData();

Object.entries(formData).forEach(([key, value]) => {
  payload.append(key, value);
});

// ✅ Send user.id directly
payload.append("user_id", userId);

// Optionally send name if needed
payload.append(
  "establishment",
  selectedUser.merchant_profile?.establishment || "Unnamed Establishment"
);


setLoading(true);

postJsonData(
  ApiEndpoints.GENERATE_INVOICE,
  payload,
  setLoading,
  (response) => {
    if (response) {
      okSuccessToast(response.data.message);
      setOpen(false);
       resetForm();
      if (onSuccess) onSuccess();
    } else {
    apiErrorToast(response.message );
    }
  },
  (error) => {
    apiErrorToast(error.message || "Error creating asset.");
  }
);

  };

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        startIcon={
          <IconButton sx={{ p: 0, color: whiteColor() }}>
            <AddCircleOutlineIcon />
          </IconButton>
        }
        size="small"
        color="success"
        variant="contained"
        sx={{
          padding: 1,
          backgroundColor: "#2F3B57",
          borderRadius: "2px",
          color: whiteColor(),
        }}
      >
        Create Invoice
      </Button>
      <Box>
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} className="sm_modal">
            <SmallLoader loading={loading} />
            <ModalHeader
              title="Create New Invoice"
              handleClose={() => {
                setOpen(false);
                resetForm();
              }}

            />
            <DialogContent>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={6} >
                  <TextField
                    fullWidth
                    select
                    label="Establishment"
                    id="establishment"
                    size="small"
                    required
                    value={establishmentId}
                    onChange={(e) => setEstablishmentId(e.target.value)}
                    variant="outlined"
                  >
                    {users.map((user) => (
                      <MenuItem key={user.id} value={user.id}>
                        {user.merchant_profile?.establishment ||
                          "Unnamed Establishment"}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Invoice Number"
                    name="invoice_no"
                    value={formData.invoice_no}
                    onChange={handleChange}
                    size="small"
                    required
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Amount"
                    name="amount"
                    value={formData.amount}
                    onChange={handleChange}
                  />
                </Grid>


                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Invoice Date"
                    name="invoice_date"
                    type="date"
                    value={formData.invoice_date}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              <Grid item xs={6}>
  <TextField
    fullWidth
    select
    label="HSN/SAC Code"
    name="hsn_sac_code"
    value={formData.hsn_sac_code}
    onChange={handleChange}
  >
    {hsnSacCodes.map((item) => (
      <MenuItem key={item.id || item.code} value={item.code || item.name}>
        {item.code || item.name}
      </MenuItem>
    ))}
  </TextField>
</Grid>
    
                    <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Description"
                    name="description"
                    multiline
                    rows={3}
                    value={formData.description}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <ModalFooter
              btn="Create"
              request={loading}
              onClick={handleSubmit}
            />
          </Box>
        </Modal>
      </Box>
    </>
  );
};

export default CreateUInvoiceModal;
